/**
 * Alpine.js JSON tree viewer component.
 * Renders a collapsible, syntax-highlighted JSON tree.
 *
 * Usage in Blade: <div x-data="jsonTree({ data: ..., expanded: true })">
 */
document.addEventListener('alpine:init', () => {
    window.Alpine.data('jsonTree', ({ data, expanded = true }) => ({
        data,
        expanded,
        init() {
            this.$refs.tree.innerHTML = this.renderNode(this.data, null, 0, this.expanded);
        },
        renderNode(value, key, depth, startOpen) {
            if (value === null) {
                return '<span class="jt-null">null</span>';
            }
            if (typeof value === 'boolean') {
                return '<span class="jt-bool">' + (value ? 'true' : 'false') + '</span>';
            }
            if (typeof value === 'number') {
                return '<span class="jt-num">' + value + '</span>';
            }
            if (typeof value === 'string') {
                const escaped = value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                if (value.length > 300) {
                    const uid = 'jt_' + Math.random().toString(36).substr(2, 9);
                    return '<span class="jt-str">&quot;'
                        + '<span id="' + uid + '_s">' + escaped.substring(0, 200) + '…</span>'
                        + '<span id="' + uid + '_f" style="display:none">' + escaped + '</span>'
                        + '&quot;</span> '
                        + '<button onclick="document.getElementById(\'' + uid + '_s\').style.display=\'none\';document.getElementById(\'' + uid + '_f\').style.display=\'inline\';this.style.display=\'none\'" class="jt-expand">[+' + (value.length - 200) + ' chars]</button>';
                }
                return '<span class="jt-str">&quot;' + escaped + '&quot;</span>';
            }
            if (Array.isArray(value)) {
                if (value.length === 0) return '<span class="jt-punct">[]</span>';
                return this.renderCollapsible(
                    '[<span class="jt-info">' + value.length + ' items</span>]',
                    value.map((item, i) =>
                        '<div class="jt-row"><span class="jt-idx">' + i + ':</span> ' + this.renderNode(item, i, depth + 1, startOpen) + '</div>'
                    ).join(''),
                    depth, startOpen
                );
            }
            if (typeof value === 'object') {
                const keys = Object.keys(value);
                if (keys.length === 0) return '<span class="jt-punct">{}</span>';
                return this.renderCollapsible(
                    '{<span class="jt-info">' + keys.length + ' keys</span>}',
                    keys.map(k => {
                        const ek = k.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                        return '<div class="jt-row"><span class="jt-key">' + ek + '</span><span class="jt-punct">: </span>' + this.renderNode(value[k], k, depth + 1, startOpen) + '</div>';
                    }).join(''),
                    depth, startOpen
                );
            }
            return String(value);
        },
        renderCollapsible(label, children, depth, startOpen) {
            const uid = 'jt_' + Math.random().toString(36).substr(2, 9);
            const open = startOpen && depth < 2;
            return '<span class="jt-toggle" onclick="var e=document.getElementById(\'' + uid + '\'),i=document.getElementById(\'' + uid + '_i\');if(e.style.display===\'none\'){e.style.display=\'block\';i.textContent=\'▼\'}else{e.style.display=\'none\';i.textContent=\'▶\'}">'
                + '<span id="' + uid + '_i" class="jt-arrow">' + (open ? '▼' : '▶') + '</span>'
                + label + '</span>'
                + '<div id="' + uid + '" class="jt-children" style="display:' + (open ? 'block' : 'none') + '">'
                + children + '</div>';
        }
    }));
});
